import CryptoJS from "crypto-js";

const decryptedModulesData = () => {
  const modulesAccessToken = localStorage.getItem("module_access");
  console.log("modulesAccessToken", modulesAccessToken);
  // Decrypt and parse permissions
  const decryptedData = modulesAccessToken
    ? CryptoJS.AES.decrypt(
        modulesAccessToken,
        process.env.REACT_APP_ENCRYPTED_KEY
      ).toString(CryptoJS.enc.Utf8)
    : null;
  const modulesData = decryptedData ? JSON.parse(decryptedData) : {};
  console.log(modulesData,"modulesData--->")
  return {
    modules: modulesData?.permissions || [],
    role: modulesData?.role || "",
    roleId: modulesData?.role_id || "",
  };
};

export default decryptedModulesData;
